import clsx from "clsx";
import React, { FC, ReactNode } from "react";

import { Icon } from "../../../icon";
import { colorScheme } from "../form-field/styles";
import { FormFieldColors } from "../form-field/types";
import { TextInputOption } from "./types";

export interface TextInputDropdownProps {
  className?: string;
  currentValue: string;
  isOpen: boolean;
  options: TextInputOption[];
  disabled?: boolean;
  getOptionClassName?: (option: TextInputOption) => string;
  onClickOption?: (option: TextInputOption) => void;
  emptyState?: ReactNode;
  color: FormFieldColors;
}

export const TextInputDropdown: FC<TextInputDropdownProps> = ({
  color,
  className,
  disabled,
  getOptionClassName,
  isOpen,
  onClickOption,
  emptyState,
  options,
  currentValue,
}) => {
  const { optionEnabledClassName, optionDisabledClassName } = colorScheme[color];
  return (
    <div
      className={clsx(
        "w-full absolute left-0 flex rounded overflow-hidden shadow",
        "z-20 fixed outline outline-2 outline-primary mt-[2px]",
        !isOpen && "invisible",
        className
      )}
    >
      <div className="flex flex-col flex-grow max-h-48 primary-scrollbar overflow-y-auto">
        {options.map((option, i) => {
          const isSelectedValue = option.label === currentValue;

          return (
            <button
              type="button"
              className={clsx(
                "py-1 px-2 text-left flex justify-between items-center",
                isSelectedValue && "font-bold",
                disabled || option.disabled ? optionDisabledClassName : optionEnabledClassName,
                i < options.length - 1 && "border border-x-0 border-t-0 border-b-gray",
                getOptionClassName?.(option)
              )}
              key={i}
              disabled={option.disabled}
              onClick={() => onClickOption?.(option)}
            >
              {option.label}
              {isSelectedValue && <Icon icon="check" className="text-primary w-4" />}
            </button>
          );
        })}
        {options.length === 0 &&
          (typeof emptyState === "string" ? (
            <div className="bg-light p-1 text-center font-thin">{emptyState}</div>
          ) : (
            emptyState
          ))}
      </div>
    </div>
  );
};
